module.exports = __webpack_public_path__ + "static/media/login_draft_bg.9627323b.png";